import Icon, { IconProps } from '../Icon';
const QuestionMarkIcon = (props: IconProps) => (
  <Icon viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M10.266 5.44a3.197 3.197 0 0 1 4.817 2.762v.001c0 .915-.741 1.739-1.794 2.407-1.27.805-2.403 2.206-2.403 3.952v.938a1 1 0 1 0 2 0v-.938c0-.836.564-1.685 1.475-2.263 1.146-.728 2.721-2.071 2.722-4.095a5.196 5.196 0 0 0-10.1-1.732 1 1 0 0 0 1.887.664 3.197 3.197 0 0 1 1.396-1.695Zm1.732 12.556a1 1 0 0 0 0 2h.014a1 1 0 0 0 0-2h-.014Z" />
  </Icon>
);
export default QuestionMarkIcon;
